import React from 'react';
import { Text } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import { IconRefresh } from '@carnica/graphics';
import styles from "./styles.pcss";
import { TARIFF_TEXTS } from "../../constants/tariff";
var cn = classNames.bind(styles);
export var TariffError = function TariffError(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('wrapper'),
    "data-t-id": "components-TariffError"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('error')
  }, /*#__PURE__*/React.createElement(Text, {
    className: cn('name'),
    color: "secondary",
    size: "xs"
  }, TARIFF_TEXTS.error), /*#__PURE__*/React.createElement(IconRefresh, {
    className: cn('refresh'),
    color: "secondary",
    onClick: onClick
  })));
};